// Valenoq — aviso de pack Dúo/Trío en el carrito.
// Si el cliente sube la cantidad de la variante "Simple" a 2 o 3 en vez de
// elegir el pack correspondiente en la página de producto, se le ofrece
// cambiar automáticamente a ese pack (mismo número de unidades, precio real
// del pack) para que no pague de más sin darse cuenta.
//
// Shopify vuelve a dibujar la tabla del carrito (carrito lateral y página)
// cada vez que cambia una cantidad, así que en vez de insertar el aviso una
// sola vez, se usa un MutationObserver que lo vuelve a colocar cada vez que
// el carrito se repinta.
(function () {
  'use strict';

  // id variante "Simple" -> pack Dúo/Trío de su mismo color
  var MAPA_PACKS = {
    '65696663142749': { // Red / 1 unidad (Simple)
      2: { id: '65756575138141', precio: 5199, ahorro: 999 }, // Red / Dúo
      3: { id: '65756575170909', precio: 8299, ahorro: 998 }  // Red / Trío
    },
    '65696663175517': { // Purple / 1 unidad (Simple)
      2: { id: '65756575203677', precio: 5199, ahorro: 999 }, // Purple / Dúo
      3: { id: '65756575236445', precio: 8299, ahorro: 998 }  // Purple / Trío
    }
  };
  var ETIQUETA_UNIDADES = { 2: 'Dúo', 3: 'Trío' };

  function moneda(cents) {
    return (cents / 100).toLocaleString('es', { style: 'currency', currency: 'EUR' });
  }

  function quitarAvisos() {
    document.querySelectorAll('[data-vq-cart-aviso]').forEach(function (el) { el.remove(); });
  }

  function insertarAviso(fila, variantId, cantidad) {
    var pack = MAPA_PACKS[variantId] && MAPA_PACKS[variantId][cantidad];
    if (!pack) return;
    if (fila.nextElementSibling && fila.nextElementSibling.hasAttribute('data-vq-cart-aviso')) return;

    var numColumnas = fila.children.length || 4;
    var tr = document.createElement('tr');
    tr.setAttribute('data-vq-cart-aviso', 'true');
    var td = document.createElement('td');
    td.colSpan = numColumnas;
    td.innerHTML =
      '<div class="vq-cart-aviso">' +
        '<span class="vq-cart-aviso__texto">🎁 Llévate ' + cantidad + ' unidades por <strong>' + moneda(pack.precio) + '</strong> con el pack ' + ETIQUETA_UNIDADES[cantidad] + ' — ahorra ' + moneda(pack.ahorro) + '</span>' +
        '<button type="button" class="vq-cart-aviso__boton">Cambiar al pack ' + ETIQUETA_UNIDADES[cantidad] + '</button>' +
      '</div>';
    tr.appendChild(td);
    fila.parentNode.insertBefore(tr, fila.nextSibling);

    var boton = tr.querySelector('.vq-cart-aviso__boton');
    boton.addEventListener('click', function () {
      cambiarAPack(fila, pack, boton);
    });
  }

  function cambiarAPack(fila, pack, boton) {
    var input = fila.querySelector('[data-quantity-line-key]');
    var lineKey = input ? input.getAttribute('data-quantity-line-key') : null;
    if (!lineKey) return;
    boton.disabled = true;
    boton.textContent = 'Cambiando…';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: pack.id, quantity: 1 }] })
        });
      })
      .then(function () {
        try { sessionStorage.setItem('vq-abrir-carrito', '1'); } catch (err) {}
        window.location.reload();
      })
      .catch(function () {
        boton.disabled = false;
        boton.textContent = 'Cambiar al pack';
      });
  }

  function revisarCarrito() {
    var huboAvisoValido = false;
    document.querySelectorAll('input.quantity__input[data-quantity-variant-id]').forEach(function (input) {
      var variantId = input.getAttribute('data-quantity-variant-id');
      var cantidad = parseInt(input.value, 10);
      var fila = input.closest('tr');
      if (!fila) return;
      if ((cantidad === 2 || cantidad === 3) && MAPA_PACKS[variantId]) {
        insertarAviso(fila, variantId, cantidad);
        huboAvisoValido = true;
      }
    });
    if (!huboAvisoValido) quitarAvisos();
  }

  var reintento = null;
  function programarRevision() {
    clearTimeout(reintento);
    reintento = setTimeout(revisarCarrito, 150);
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('input.quantity__input[data-quantity-variant-id]');
    if (input) setTimeout(revisarCarrito, 50);
  });

  // Vídeos pequeños del producto: reproducción automática nativa (atributo
  // autoplay en el <video>). Esto solo marca visualmente el botón de play
  // como "oculto" cuando el vídeo ya está sonando solo, y sirve de
  // alternativa por si el navegador del cliente bloquea igualmente el
  // autoplay silenciado.
  function marcarReproduciendo(video) {
    var item = video.closest('.vq-carrito-videos__item');
    if (item) item.setAttribute('data-vq-reproduciendo', '1');
  }

  document.addEventListener(
    'playing',
    function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('vq-carrito-videos__video')) {
        marcarReproduciendo(e.target);
      }
    },
    true
  );

  document.addEventListener('click', function (e) {
    var item = e.target.closest && e.target.closest('.vq-carrito-videos__item');
    if (!item) return;
    var video = item.querySelector('.vq-carrito-videos__video');
    if (!video) return;
    if (video.paused) {
      video.play().then(function () { marcarReproduciendo(video); }).catch(function () {});
    } else {
      video.pause();
      item.removeAttribute('data-vq-reproduciendo');
    }
  });

  function forzarAutoplayVideos() {
    document.querySelectorAll('.vq-carrito-videos__video').forEach(function (video) {
      // Se fija la propiedad además del atributo HTML: algunos navegadores
      // solo respetan el autoplay silenciado si "muted" está puesto también
      // por JavaScript antes de llamar a play().
      video.muted = true;
      var intento = video.play();
      if (intento && typeof intento.then === 'function') {
        intento.then(function () {
          marcarReproduciendo(video);
        }).catch(function () {});
      }
    });
    // El vídeo más pesado a veces tarda un instante en arrancar solo (pierde
    // el turno del autoplay si los 3 se piden a la vez): un par de
    // reintentos cortos lo dejan encarrilado sin que el cliente tenga que
    // tocar nada.
    [600, 1500].forEach(function (espera) {
      setTimeout(function () {
        document.querySelectorAll('.vq-carrito-videos__video').forEach(function (video) {
          if (video.paused) {
            video.play().then(function () { marcarReproduciendo(video); }).catch(function () {});
          }
        });
      }, espera);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    revisarCarrito();
    forzarAutoplayVideos();

    // Se observa <body> entero (no solo la tabla del carrito) porque Shopify
    // a veces sustituye la tabla completa por una nueva al repintar tras un
    // cambio de cantidad, y un observer atado al nodo viejo dejaría de ver
    // cambios en la tabla nueva.
    var observer = new MutationObserver(programarRevision);
    observer.observe(document.body, { childList: true, subtree: true });

    var drawer = document.querySelector('cart-drawer');

    try {
      if (sessionStorage.getItem('vq-abrir-carrito') === '1') {
        sessionStorage.removeItem('vq-abrir-carrito');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      }
    } catch (err) {}
  });
})();
